export default "__VITE_ASSET__DjtotWEq__"